import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Help.css";
import { FaArrowRight, FaHeadset } from "react-icons/fa";

const HelpCenter = () => {
    const navigate = useNavigate();

    const sections = [
        { 
            title: "Getting Started", 
            description: "Everything you need to start a company with BooksComply", 
            link: "/getting-started",
            icon: <FaArrowRight className="section-icon" />
        },
        { 
            title: "Resources", 
            description: "Helpful guides, tips, and additional information", 
            link: "/resources",
            icon: <FaHeadset className="section-icon" />
        },
        { 
            title: "Refund and Pricing", 
            description: "Transparent pricing and hassle-free refund policy", 
            link: "/refund",
            icon: <FaArrowRight className="section-icon" />
        },
    ];

    return (
        <div className="hc-container">
            <header className="hc-header">
                <div className="hc-container-1200">
                    {/* <div className="hc-header-content">
                        <div className="hc-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="hc-top-bar">
                            <a href="/submitrequest" className="hc-submit-btn">
                                <FaHeadset className="btn-icon" /> Submit a Query
                            </a>
                        </div>
                    </div> */}
                </div>
            </header>
            
            <main className="hc-main-content">
                <div className="hc-container-1200">
                    <div className="hc-hero">
                        <h1>How can we help you today?</h1>
                        <p>Find answers to common questions and get support for your BooksComply account.</p>
                        {/* <div className="hc-search-container">
                            <input 
                                type="text" 
                                placeholder="Search help articles..." 
                                className="hc-search-input"
                            />
                            <button className="hc-search-btn">Search</button>
                        </div> */}
                    </div>

                    <div className="hc-sections-grid">
                        {sections.map((section, index) => (
                            <div 
                                key={index}
                                className="hc-section-card"
                                onClick={() => navigate(section.link)}
                            >
                                <div className="section-icon-container">
                                    {section.icon}
                                </div>
                                <div className="section-content">
                                    <h3>{section.title}</h3>
                                    <p>{section.description}</p>
                                    <span className="learn-more">Learn more <FaArrowRight /></span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="hc-contact-section">
                        <h2>Still need help?</h2>
                        <p>Our support team is here to assist you with any questions or issues.</p>
                        <a href="/submitRequest" className="hc-contact-btn">Contact Support</a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default HelpCenter;